import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

/**
 * BFF mode : pas de Bearer token côté browser, l'authentification est portée
 * par le cookie HttpOnly. Cet interceptor s'assure que toutes les requêtes
 * vers l'API embarquent le cookie via withCredentials.
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  // `/api/` avec slash final : évite de matcher d'éventuels chemins comme `/apixyz`
  // (aligné sur le reste du codebase et le routage nginx en prod).
  if (req.url.startsWith('/api/')) {
    return next(req.clone({ withCredentials: true }));
  }
  return next(req);
};
